<template>
  <transition @appear="animate">
    <div class="container">
      <section class="artist">
        <router-link to="/">
          <img class="piece artist" src="@/assets/logo.svg" alt />
        </router-link>
        <div class="piece headers">
          <h2>Affak Khan</h2>
          <h3>Visualizer, Illustrator</h3>
          <p>Mumbai, India</p>
          <div class="social">
            <a class="link" href="https://www.facebook.com/affak.khan.9">
              <img src="@/assets/facebook.svg" alt />
            </a>
            <a class="link" href="https://www.instagram.com/puzzle1x24/">
              <img src="@/assets/instagram.svg" alt />
            </a>
          </div>
          <h4>
            <a class="link" href="mailto:aafak7@gmail.com">aafak7@gmail.com</a>
          </h4>
          <p class="job">
            <span class="available">available</span> for hire / freelance
          </p>
        </div>
        <div class="piece info">
          <p>
            Hi, After graduating from art school. I took a job at a big studio and
            worked with small startups to giants like coca-cola.
          </p>
        </div>
      </section>
      <div class="codedleaf">
        <p>
          powered by
          <a href="https://codedleaf.in" rel="noopener" class="link" target="_blank">
            <span>codedleaf</span>
          </a>
        </p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "About",
  props: ["pageRender"],
  methods: {
    animate: function() {
      this.$anime({
        targets: ".piece",
        duration: 1250,
        opacity: [0, 1],
        translateY: ["-300%", 0],
        easing: "easeOutSine",
        delay: this.$anime.stagger(200, { from: "first" })
      });
    }
  },
  mounted: function() {
    this.animate();
  }
};
</script>

<style scoped lang="scss">
.container {
  pointer-events: auto;
  padding: 2rem;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: scroll;
  padding-bottom: 4rem;

  @include bigScreen {
    overflow: inherit;
  }

  .artist {
    margin: auto;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: column;

    img.artist {
      max-width: 300px;
      width: 50vw;
      @include bigScreen {
        width: 100%;
      }
    }

    .info {
      width: 100%;

      p {
        padding: 0.3em;
      }
    }

    .headers {
      padding: 0.3em;
      width: 100%;

      .social {
        display: flex;
        justify-content: center;
        padding: 0.2em;

        img {
          height: 2em;
          width: 2em;
        }
      }

      .job {
        font-size: 0.9em;
        .available {
          color: $available;
        }
      }
    }

    @include bigScreen {
      display: grid;
      grid-template-areas: "header image info";
      grid-template-columns: 1.3fr 1fr 1.3fr;
      grid-gap: 1em;
      font-size: 1.5em;

      img {
        grid-area: image;
        width: 100%;
      }

      .headers {
        grid-area: header;
        text-align: end;
        .social {
          justify-content: flex-end;
        }
      }

      .info {
        width: 100%;
        grid-area: info;
        text-align: start;
        font-size: 1.2em;
      }
    }
  }

  .codedleaf {
    font-size: 0.9rem;
    a {
      font-weight: bold;
    }

    @include bigScreen {
      font-size: 1.5rem;
    }
  }
}
</style>
